let newBaseApi = `https://api.quizard.live`;

export const apiUrl = {
    activityLog:`${newBaseApi}/activity-logs/`,
    getEventRules:`${newBaseApi}/rules/`
}